import StarRating from "vue-star-rating";
import { mapGetters } from "vuex";

export default {
    components: {
        StarRating
    },

    props: {
        tabObj: {
            type: Object
        }
    },

    data: function () {
        return {
            class_rating: 0,
            currentDate: "",
            isEnrolling: false, // Flag to prevent multiple clicks
        };
    },

    computed: {
        ...mapGetters(["userType", "studentId"]),
    },

    methods: {
        setRating: function (rating) {
            this.$emit('setRating', rating)
        },

        confirmEnroll() {
            this.isEnrolling = false; // Reset flag before showing dialog
            this.$modal.show('dialog', {
                title: 'အတည်ပြုခြင်း!',
                text: 'ဤအတန်းကိုတက်မှာ သေချာပြီလား?',
                buttons: [{
                        title: 'တက်မည်',
                        default: true,
                        handler: () => {
                            if (!this.isEnrolling) {
                                this.isEnrolling = true; // Prevent further clicks
                                this.$emit('enrollClass').finally(() => {
                                    this.isEnrolling = false; // Reset after completion
                                });
                            }
                        }
                    },
                    {
                        title: 'မတက်ပါ',
                        handler: () => {
                            this.$modal.hide('dialog');
                        },
                    }
                ]
            });
        },
    },
    mounted() {
        const today = new Date();
        this.currentDate = today.toISOString().split("T")[0];
    },
    created() {
        this.isStudent = this.userType == "student" ? true : false;
        this.isLogin = this.studentId ? true : false;
    }
};